import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {WeeeSystems} from '../../../models/weee_systems.interface';
import {appConfig} from '../../../../config/config';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {CreateWeeeSystemComponent} from '../create-weee-system/create-weee-system.component';
import {EditWeeeSystemComponent} from '../edit-weee-system/edit-weee-system.component';
import {Countries} from '../../../models/countries.interface';
import {GenericDialogComponent} from '../../../../shared/components/generic-dialog/generic-dialog.component';

@Component({
  selector: 'app-weee-system-table',
  templateUrl: './weee-system-table.component.html',
  styleUrls: ['./weee-system-table.component.scss']
})
export class WeeeSystemTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['description', 'country.name', 'member', 'edit'];

  @Input()
  countries!: Countries[];
  @Input()
  weeeSystems!: WeeeSystems[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadWeeeSystems: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();
  @Output()
  updateWeeeSystemStatus: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  deleteWeeeSystem: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly dialog: MatDialog) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadWeeeSystems.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadWeeeSystems.emit({page: event.pageIndex, size: event.pageSize, sort: this.sort.active, direction: this.sort.direction});
  }

  addWeeeSystem(): void {
    const dialogRef = this.dialog.open(CreateWeeeSystemComponent, {data: this.countries, maxWidth: 600, width: 'inherit'});

    dialogRef.componentInstance.createEvent.subscribe(() => {
      this.loadWeeeSystems.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

  editWeeeSystem(value: WeeeSystems): void {
    const dialogRef = this.dialog.open(EditWeeeSystemComponent, {data: {weeeSystem: value, countries: this.countries}, maxWidth: 600, width: 'inherit'});

    dialogRef.componentInstance.editEvent.subscribe(() => {
      this.loadWeeeSystems.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

  updateWeeeSystem(ws: WeeeSystems, deleteWeeeSystem: boolean): void {
    const dialogRef = this.dialog.open(GenericDialogComponent,
      {
        data:
          {
            title: `${deleteWeeeSystem ? 'Delete' : (ws.status === 'ACTIVE' ? 'Disable' : 'Enable')} WEEE System`,
            text: `Are you sure you want to ${deleteWeeeSystem ? 'delete' : (ws.status === 'ACTIVE' ? 'deactivate' : 'activate')} the selected item?`
          }
      });
    dialogRef.componentInstance.confirm.subscribe((confirm: boolean) => {
      if (confirm) {
        if (deleteWeeeSystem) {
          this.deleteWeeeSystem.emit(ws.id);
        }
        else {
          this.updateWeeeSystemStatus.emit(ws.id);
        }
      }
      dialogRef.close();
    });
  }

}
